import { render } from "./ErroRecarga.vue?vue&type=template&id=884bc4a6"
import script from "./ErroRecarga.vue?vue&type=script&lang=js"
export * from "./ErroRecarga.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__